export const StainlessSteelBarData = [
  {
    text1:
      "Stainless Steel Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "The mechanical properties for the various tempers of these Stainless Steel Hollow Bars are checked by debasing working and not by warmth treating. Tempered material of our Stainless Steel Hexagonal Bars has an assertion and is utilized for basic and shallow included parts. These Stainless Steel Triangular Bars has astonishing assertion from oxidation at temperatures up to 1550 Degree F, yet isn't underwrite for utilize in excess of 1600 Degree F.",
    Specifications: {
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];

export const  SSBarGradeData=[

  {
    id:1,
    grade:'SS 304 Round Bar',
    link:'/SS304BarGrade'
  },
  {
    id:2,
    grade:'SS 304L Round Bar',
    link:'/SS304LBarGrade'
  },
  {
    id:3,
    grade:'SS 304H Round Bar',
    link:'/SS304HBarGrade'
  },
  
  {
    id:7,
    grade:'SS 310S Round Bar'
    ,
    link:'/SS310SBarGrade'
  },
  {
    id:8,
    grade:'SS 310H Round Bar',
    link:'/SS310HBarGrade'
  },
  {
    id:9,
    grade:'SS 316 Round Bar',
    link:'/SS316BarGrade'
  },
  {
    id:10,
    grade:'SS 316H Round Bar',
    link:'/SS316HBarGrade'
  },

  {
    id:12,
    grade:' SS 316L Round Bar',
    link:'/SS316LBarGrade'
  },
  {
    id:13,
    grade:'SS 316Ti Round Bar',
    link:'/SS316TiBarGrade'
  },
    
  {
    id:18,
    grade:'SS 904L Round Bar',
    link:'/SS904LBarGrade'
  },
 
  ]
export const StainlessSteel304BarData = [
  {
    text1:
      "Stainless Steel 304 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "ASTM A276, ASTM A479 are benchmarks of these class bars. These are bars are made with the arranging system. Bars are set by treating, cold depiction, and hot structure process for developing continuously evident quality. S30400 is the examination of set steel in the assembled numbering structure. Square, hex, round, square shape, billet, ingot are a few conditions of these bars. Wrapped up by mind blowing dull flawless, matte finishing, BA flawlessness, and NO.4 wrap up. These are open in various estimations not by any means proportional to 18 mm to 57 mm, the customer can structure any remarkable estimations as appeared by their necessities. Length contrasts from 1 to 6 meter and can be adjusted. ",
    Specifications: {
      " Grade": " Grade",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];
export const StainlessSteel304LBarData = [
  {
    text1:
      "Stainless Steel 304L Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Stainless Steel 304L Bars which are all around checked by the social gathering of masters so as to guarantee that these things are bore witness to utilize and perform with no deformities. Treated Steel 304 Bars (UNS S30400) has urgent use/oxidation balancing activity by perfection of the chromium content. Remarkable conditions of utilizing Stainless Steel 304L Round Bars solidify low carbon content that sheds carbon precipitation in the welding structure. Stainless Steel 304L Round Bars higher tractable yield quality and has low temperature properties reacting shocking to setting up by malady working.",
    Specifications: {
      " Grade": "SS 304L",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];

export const StainlessSteel304HBarData = [
  {
    text1:
      "Stainless Steel 304H Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Stainless Steel 304H Bars offers mind blowing surface completing and dimensional precision. These are referenced by different complete benchmarks for guaranteeing quality.SS 304H Bars is routinely utilized in the most shocking conditions, for example, blend overseeing, sullying control, pound and paper creation, stream and normal waste treatment, and recuperation of savage vaporous oil.",
    Specifications: {
      " Grade": "SS 304L",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];
export const StainlessSteel310SBarData = [
  {
    text1:
      "Stainless Steel 310S Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "These bars are other than known for their temperature resistivity and can withstand phenomenally high temperature even up to 2100 degree. The bars other than have mind blowing hardness since they are utilized in different present and gathering affiliations. These Stainless Steel 310s Bars have immense application in the concealing without end of various zones of general machines thermocouple and even in air transportation endeavors. These bars have wide application really working out exactly as expected of pieces of warmth treating boxes, hydrogenation parts, warming stove contraption, radiator sections and particular various materials. The Stainless Steel 310s Bars are all around endeavored before transporting them in the market. The bars are completely stuffed and securely transported to our customers.",
    Specifications: {
      " Grade": "SS 310S",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];
export const StainlessSteel310HBarData = [
  {
    text1:
      "Stainless Steel 310H Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Stainless Steel 310H Bars offers bewildering security from isolating and scratched spot. These are best known for its affirmed quality and versatility. These bars are talented to hold up under abnormal burdens with no checking, which makes it perfect for constructional and building purposes. Bars will everything considered remain in most high-temperature conditions. These bars can without a colossal proportion of a stretch be changed by any catch structure or edge. Machining cost is lesser than some other kind of bar. The intergranular test is done in for invigorating bar.",
    Specifications: {
      " Grade": "SS 310H",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];
export const StainlessSteel316BarData = [
  {
    text1:
      "Stainless Steel 316 Round Bar Manufacturers In Mumbai, Stainless Steel 316 Round Bar Exporters In Mumbai, Stainless Steel 316 Round Bar Suppliers In Mumbai, Stainless Steel 316 Round Bar Importers In Mumbai, Stainless Steel 316 Round Bar Stockists In Mumbai",
    text2:
      "Stainless Steel 316 Round Bar Manufacturers In India, Stainless Steel 316 Round Bar Exporters In India, Stainless Steel 316 Round Bar Suppliers In India, Stainless Steel 316 Round Bar Importers In India, Stainless Steel 316 Round Bar Stockists In India",
    text3:
      "Stainless Steel 316 Bars are totally demolished and endeavored before passing on. There are various tests like the setting test, flaring test, intergranular test, made examinations and various examinations are made to ensure that the made thing are of typical quality and are okay for each moved application. The transportation of these Stainless Steel 316 Bars is done in all around guaranteed and ensured packaging. The bars are transported with uncommon thought and it is ensured that the things don't get hurt while shipping them to different national and all around targets.",
    Specifications: {
      " Grade": "SS 316",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];

export const StainlessSteel316LBarData = [
  {
    text1:
      "Stainless Steel 316L Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Set Steel 316L Rods is a philosophy of Stainless Steel 316 and flounders by having a lower Carbon content close by somewhat lower yield and versatile characteristics. Concerning national and all around nature of foul materials, we in like way offer these UNS S31603 Round Bars (everything considered called WNR 1.4404 Bars) in changed sizes and thicknesses as had all the earmarks of being express requests by our regarded customers at market driving costs.",
    Specifications: {
      " Grade": "SS 316L",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];
export const StainlessSteel316HBarData = [
  {
    text1:
      "Stainless Steel 316H Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India"
      ,
    text2:
      "",
    text3:
      "There are various tests that join setting square test, hardness test, smoothing test, intergranular devastating test, creation examinations and various tests. These tests are all around influenced requesting the persuading thought regarding the made thing and accreditation that the bars are fit for all the particular application in current fields. These Stainless Steel 316H Bars are squashed absolutely to ensure that the bars don't get hurt or turned while transportation to different serious and national markets.",
    Specifications: {
      " Grade": "SS 316H",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276 / A479, ASME SA276 / A479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];
export const StainlessSteel316TiBarData = [
  {
    text1:
      "Stainless Steel 316Ti Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "These are encircled by hot managing frameworks and later treated by toughening process for growing additional hardness. These are done by matt, BA verification and lessening stunning clean for additional surface fulfillment. UNS S31635 is examination of these bars. Stainless Steel 316Ti Bars are make by unadulterated grungy materials which aggregates nature of bars. Bars are inspected by quality mentioning test for clearing any age comes up short. We gives these bars in most sensible costs; you can purchase these for improving your structure works. These are passed on in packs in plastic wrapping.",
    Specifications: {
      " Grade": "SS 316Ti",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276 / A479, ASME SA276 / A479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];
export const StainlessSteel904BarData = [
  {
    text1:
      "Stainless Steel 904L Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Modi metals. is guaranteed by different clearing measures. All the made bars we pass on are assessed with solid quality assertion test. ASTM B649, ASME SB649 are models of these bars. Gathered warms treating process is done in bars for removing any blow openings inside bars structure which makes its quality and odds of bafflements. UNS N08904 is the material evaluation utilized in the party of bars. Square, hex, round, square shape, billet are limited open in these sorts of bars. Estimations are passed on by checks and changed plainly. Stainless Steel 904L Bars are made with bleeding edge gear that makes surface acknowledgment and dimensional precision of bars. You can purchase these bars everything considered sensible costs from our company. These are full in kind of gatherings and after that wrapped by plastic keeping from any air harms.",
    Specifications: {
      " Grade": "SS905L",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Form: "Round Bars, round Bars, Flat Bars, Threaded Bars, Hollow Bars, Hexagonal Bars, Triangular Bars",
      Application:
        "Most commonly used in petroleum refineries, Boilers, Heat exchangers, Condensers, Pipelines, Cooling towers, Steam exhausts, Electric generation plants, On occasion will be found in fertilizer and chemical plants.",
      Specification: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Standard: "ASTM A276, ASME SA276 / ASTM A479 ASME SA479",
      "Round Bars": "Outside Diameter in the range of 4mm to 500mm",
      "Bright Bars": "Outside Diameter in the range of 4mm to 100mm",
      "round Bar": "18mm – 57mm (11/16″ to 2-3/4″)",
      "round Bars": "18mm – 47mm (11/16″ to 1-3/4″)",
      "Flat Bars": "1/2” to 10” in thickness range of 2mm to 150mm",
      Length: "1 to 6 Meters, Custom Cut Lengths",
    },
    chemical: {},
  },
];

export const  InconelBarGradeData=[

  {
    id:1,
    grade:'Inconel 600 Round Bar',
    link:'/Inconel600BarGrade'
  },
  {
    id:2,
    grade:'Inconel 601 Round Bar',
    link:'/Inconel601BarGrade'
  },
  {
    id:3,
    grade:'Inconel 625 Round Bar',
    link:'/Inconel625BarGrade'
  },
  
  {
    id:4,
    grade:'Inconel 800 Round Bar'
    ,
    link:'/Inconel800BarGrade'
  },
  {
    id:5,
    grade:' Inconel 801 Round Bar',
    link:'/Inconel801BarGrade'
  },
  {
    id:6,
    grade:'Inconel 825 Round Bar',
    link:'/Inconel825BarGrade'
  },
  
]

export const InconelBarData = [
  {
    text1:
      "Inconel Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "A dash of the territory of present or potential use these Inconel Hollow Bars is: Acetic ruinous/Acetic Anhydride, cellophane passing on, chlorine spargers, chlorination structures, circuit board scratching gear, complex dangerous/substance mixes, fans and blowers. Our Inconel Hexagonal Bars can withstand incredibly high temperatures and is segregating safe, which is other than given in this condition.",
    Specifications: {
      " Specifications": "ASTM B166 / ASTM SB166",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const Inconel600BarData = [
  {
    text1:
      "Inconel 600 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India ",
    text2:
      "",
    text3:
      "Inconel 600 Round Bars, which is a standard structure material utilized for different purposes in the splendor – treating industry. Inconel 600 round Bars shows raised degrees of affirmation from stress – use breaking, exhaust gases, disintegrating by high feelings water, climatic use, halogen, and most trademark acids and inorganic acids.",
    Specifications: {
      " Specifications": "ASTM B166 / ASTM SB166",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const Inconel601BarData = [
  {
    text1:
      "Inconel 601 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "ASTM B166, DIN 17752 are models consider while making these bars. Round bars are made by a hot moving framework for removing any blow openings inside the material structures. NO6601 is the material examination of Inconel bars in the bound together numbering structure. These are set by the treating structure. Square, hex, round, square shape, billet, are states of bars. Length shifts from 1 to 6 meter; remove across over growthes from 0.01 mm to 250 mm and can by custo9mized as indicated by client needs. Producers left a few adaptabilities so that ought to be conceivable later according to necessities. inconel bars are done by the matte satisfaction, BA complete, and significant diminishing clean.",
    Specifications: {
      " Specifications": "ASTM B166 / ASTM SB166",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const Inconel625BarData = [
  {
    text1:
      "Inconel 625 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Inconel 625 Round Bar, Suppliers Of ASTM B446 Inconel 625 Round Bar, 625 Inconel Alloy Forged Bars Exporter, Inconel 625 Round Bar, Inconel WERKSTOFF NR. 2.4856 Round Bars Manufacturer In India. Hot Rolled Inconel 625 Round Bar, Inconel 625 Hexagonal Bar, 625 Inconel Polished Bar, Specialist Distributor Of ASTM B166 Alloy 625 Threaded Bar, Alloy 625 Flat Bar, 625 Alloy Black Bar Exporter In India.",
    Specifications: {
      " Specifications": "ASTM B446 / ASTM SB446",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const Inconel800BarData = [
  {
    text1:
      "Inconel 800/800H/800HT Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Raw materials are endeavored and after that go for getting ready for social affair bars. Improvement of progress and structures puts aside a couple of minutes of Incoloy 800/800H/800HTbars unequivocal. These bars go with quality check test for discharging conveying harms. These are squashed in sort of packs and encased by plastic for imagining any barometrical harms. You can utilize these bars for entire course of action connection.",
    Specifications: {
      " Specifications": "ASTM B408 / ASTM SB408",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const Inconel801BarData = [
  {
    text1:
      "Inconel 801 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Modi Metals. is a standard creator, authority, and exporter of Incoloy 801 Bars. We are utilizing incited apparatus and improvement to make this Inconel bar aftereffect of examination 801. We are passing on this bar to meet all worldwide and national benchmarks and different industry measures. We are improvement Incoloy bar in different size, estimation, thickness, and group transversely finished or as showed up by the particular vitality of our supporters. You can get this 801 Incoloy bar from our market shop at a sensible market cost. This bar thing is utilized in different undertakings and is routinely referenced by different clients in the market.",
    Specifications: {
      " Specifications": "ASTM B408 / ASTM SB408",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const Inconel825BarData = [
  {
    text1:
      "Inconel 825 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Inconel is a composite that is on an unfathomably basic estimation from the social event of austenitic chromium and nickel superalloys. This composite is immune to oxidation and use and suits each kind of condition and temperature. In any case, if we talk about Incoloy 825 bars, these bars are known best for their stunning properties and features which help them to withstand in essential temperature and condition. In like manner, if you are finding the most strong and recognized creators, by then Modi Metals is the right decision for you. They are one of the major makers who offer the best idea of bars far and wide.",
    Specifications: {
      " Specifications": "ASTM B425 / ASTM SB425",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];



export const  MonelBarGradeData=[

  {
    id:1,
    grade:'Monel 400 Round Bar',
    link:'/Monel400BarGrade'
  },
  {
    id:2,
    grade:'Monel K500 Round Bar',
    link:'/MonelK500BarGrade'
  },
  

  
]

export const RoundBarOptionData=[
  {
  id:1,
  grade:"SS Round Bar",
  link:'SSRoundBar',                           

},
{
  id:2,
  grade:"Inconel Round Bar",
  link:'/InconelRoundBar',

},
{
  id:3,
  grade:"Monel Round Bar",
  link:'/MonelRoundBar',
  
},
{
  id:4,
  grade:"NICKEL Round Bar",
  link:'/NickelRoundBar',
},
{
  id:6,
  grade:"TITANIUM Round Bar",
  link:'/titaniumCRoundBar',

  
},

{
  id:8,
  grade:"A-286 Round Bar",
  link:'/A286RoundBar',

},
{
  id:9,
  grade:"SMO 254 Round Bar",
  link:'/SMO254RoundBar',
 
  
},
{
  id:10,
  grade:"Hastelloy Round Bar",
  link:'/HastelloyRoundBar',

  
},
{
  id:5,
  grade:"Alloy 20 Round Bar",
  link:'/Alloy20RoundBar',

  
},
{
  id:12,
  
  grade:"Duplex Superduplex Round Bar",
  link:'/DuplexSuperduplexRoundBar',
 
  
},
]

export const MonalBarData = [
  {
    text1:
      "Monel Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India",
    text2:
      "",
    text3:
      "Monel Triangular Bars is strengthened at 1038 Degree C (1900 Degree F) trailed by cooling. In deaerated 1 % sodium hydroxide at 600 Degree F (316 Degree C), Monel Bars events of did not part. Use rates for Monel Rods in oxidizing and diminishing sulfidizing conditions, which is also settled by disease working. Petrochemical works time of reactant recuperation in the use of more than 700 Degree C grasped the use of Monel Alloy Bars, in order to get a competently drawn out coalition life.",
    Specifications: {
      " Specifications": "ASTM B164 / ASTM SB164",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const Monel400BarData = [
  {
    text1:
      "Monel 400 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "Monel Alloy Round Bars, which is being an absolutely huge thing in planning attempts, and over this range is thoroughly required by the budgetary perspectives. In any case, this Monel round Bars are made and overseen by using best nature of tempered steel in approval by systems for the general quality benchmarks and checks. Monel Flat Bars makes them magnificent features to offer, for instance, insusceptible to use, exact estimations, free from a help, and that is just a gander at something progressively noticeable. Our firm fixations in giving, trading and making an associated assembling of these Monel Threaded Bars.",
    Specifications: {
      Specifications: "ASTM B164 / ASTM SB164",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
        Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI.",
      Grade: "Monel Alloy 400 ",
      Form:"Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const MonelK500BarData = [
  {
    text1:
      "Monel K500 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "MONEL ALLOY K500 Bar, ASTM B865 Monel K500 Round Bars, Monel UNS N05500 Bright Bar, K500 Monel Triangular Bar, Monel K500 Round Bar, Monel Alloy K500 Rods Suppliers And Dealer In Mumbai, India. Monel K500 Round Bar, Suppliers Of ASTM B865 Monel K500 Round Bar, K500 Monel Alloy Forged Bars Exporter, Alloy K500 Round Bar, Monel WERKSTOFF NR. 2.4375 Round Bars Manufacturer In India. Monel Alloy K500 Flat Bar, Monel K500 Hexagonal Bar, Hot Rolled Monel K500 Round Bar, Monel K500 Cold Drawn Round Bar, K500 Monel Polished Bar, Specialist Distributor Of ASTM B865 Alloy K500 Threaded Bar, K500 Alloy Black Bar Exporter In India.",
    text3:
      "All these can be changed by client's fundamentals. These are passed on with hot dealing with structure for evacuating any inside social affair deformations. ASTM B 865, ASTM SB 865 are standard of these bars. These are treated with the toughening technique for extra setting. UNS NO5500 is the material assessment of these bars.Round bars are made with the help of mind leaving behind the radiographic system. Monel K-500 Bars are made and pass on by Sparsh Impex. Give five star surface finishing and dimensional precision. Monel bars are full in plastic wrapping for changing any rust or compound damages. These are the best quality bars used for structure works.",
    Specifications: {

     Specifications: "ASTM B865 / ASTM SB865",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
        Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI.",
      Grade: "Monel K500",
      Form:"Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",

    },
    chemical: {},
  },
];

export const  NickelBarGradeData=[

  {
    id:1,
    grade:'Nickel 200 Round Bar',
    link:'/Nickel200BarGrade'
  },
  {
    id:2,
    grade:'Nickel 201 Round Bar',
    link:'/Nickel201BarGrade'
  },
  
]

export const NickelBarData = [
  {
    text1:
      "Nickel Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "Nickel Hollow Bars are being mass – passed on dissenting the different needs of our well – regarded budgetary perspectives. We too offer these things in different examinations, for instance, Nickel Round Bars and Nickel Round Bars. By at that point, these Nickel Hexagonal Bars are in like manner being offered in different sizes and shapes to our customers. In this framework, Nickel Triangular Bars is reacted with carbon monoxide inside watching a sulfur control at around 40 Degree C – 80 Degree C to shape nickel carbonyl.",
    Specifications: {
      " Specifications": "ASTM B160 / ASTM SB160",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const Nickel200BarData = [
  {
    text1:
      "Nickel 200 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "Nickel Alloy 200 Round Bars to the regarded clients, which is expediently kept up by central mechanical structure. Nickel 200 round Bars is a financially unalloyed nickel that introductions shocking isolating square and has truly low electrical resistivity. Nickel 200 Flat Bars are secured wrapped materials, and is a financially unadulterated material that shows phenomenal pulling back check. Nickel 200 Triangular Bars is irrelevance solid procedure heat safe blend with industriously comprehended techniques from oxidization underneath carefully cyclic conditions through 2000 Degree F. Amalgam 200 round Bars is bowed from steel, where in explanation unadulterated steels that are totally more vigorously and will continue running in insufficiency figure set rapidly. Amalgam 200 Flat Bars is a quality denying unadulterated – steel with high security from oxidization scaling and has high bore at raised temperatures. Compound 200 Threaded Bars is other than open close by made sizes and shapes to our clients at reasonable expense.",
    Specifications: {
      " Specifications": "ASTM B160 / ASTM SB160",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const Nickel201BarData = [
  {
    text1:
      "Nickel 201 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "The greater bit of blends from Nickel 201 Threaded Bars that are released to nature will adsorb to residue or soil particles and become fixed in this way. In acidic ground nevertheless, Nickel 201 Hollow Bars will without a doubt end up being progressively flexible and it will every now and again flush out to the groundwater. We do understand that high nickel obsessions with sandy soils from Nickel 201 Hexagonal Bars can unquestionably damage plants and high nickel centers in surface waters can reduce the advancement rates of green development. Nickel 201 Triangular Bars, anyway they as a general rule make assurance from nickel eventually. In any case, Nickel 201 Bars isn't only great as an essential segment, where it can in like manner be risky when the most extraordinary conventional wholes are outperformed. Nickel 201 Rods is consistently used to give a cautious covering to various metals, and finely apportioned nickel is a driving force for hydrogenating vegetable oils.",
    Specifications: {
      " Specifications": "ASTM B160 / ASTM SB160",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.01 mm to 250 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];


export const TitaniumBarGradeData = [
  {
    id: 1,
    grade: "Titanium Gr 1 Round Bar",
    link: "/TitaniumGr1BarGrade",
  },
  {
    id: 2,
    grade: "Titanium Gr 2 Round Bar",
    link:"/TitaniumGr2BarGrade",
  },
  {
    id: 3,
    grade: "Titanium Gr 3 Round Bar",
    link: "/TitaniumGr3BarGrade",
  },
  {
    id: 4,
    grade: "Titanium Gr 4 Round Bar",
    link: "/TitaniumGr4BarGrade",
  },
  {
    id: 5,
    grade: "Titanium Gr 5 Round Bar",
    link: "/TitaniumGr5BarGrade",
  },
];

export const TitaniumBarData = [
  {
    text1:
      "Titanium Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "Meanwhile, Titanium Triangular Bars are in like manner being offered in different sizes and shapes to our customers. Titanium Bars has a base yield nature of 275 Mpa (40 ksi), and by and large low sections of dirtying impact pieces, which spots it between to the degree quality. This isn't completely a consequence of low thickness and use impediment of Titanium Rods which can be imploringly welded, hot and cold worked and machined. Ti Alloy Round Bars is used where ruin impediment is an enormous viewpoint, or where working temperatures cripple the use of aluminum. Ti Alloy Bars is used in a wide portion of mechanical applications from oil and gas and expected to marine endeavors.",
    Specifications: {
      " Specifications": "ASTM B348/ ASTM SB348",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const TitaniumGr1BarData = [
  {
    text1:
      "Titanium Gr 1 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "Titanium Alloy DIN 3.7025 Hex Bars, Titanium Grade1 Flat Bar Exporter, Ti CP Gr 1 Square Bars Leading Manufacturers. Exporter, maker and supplier of Titanium Alloy Grade 1 Round Bars in India. Titanium Grade 1 Round Bars are fiscally unadulterated and is the gentlest titanium, where it has the most significant malleability. Titanium Alloy Grade 1 Rods has incredible infection surrounding characteristics and gives wonderful disintegration resistance. Titanium Grade 1 Rods also has mind blowing welding properties and high impact durability.",
    Specifications: {
      " Specifications": "ASTM B348/ ASTM SB348",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const TitaniumGr2BarData = [
  {
    text1:
      "Titanium Gr 2 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "The customers can grab these Titanium Grade 2 Bars from any of the on the web or pulled back vendors and pick the estimation and shape as showed up by their necessities. The Titanium Grade 2 Bars are totally tried and reviewed before passing on. There are various tests that wire the hardness test, intergranular use test, evolving test, creation examinations, setting hindrance test, and basically other examination. These tests are totally proposed to keep up a high degree of the made things and the request that the made thing are okay for all the mechanical use. The transportation or the bars is done with astonishing thought and it is ensured that the things don't get injured while transportation.",
    Specifications: {
      " Specifications": "ASTM B348/ ASTM SB348",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const TitaniumGr3BarData = [
  {
    text1:
      "Titanium Gr 3 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "The association plant is outfitted with an extent of machines and pushed getting ready workplaces that give enormous versatility to meet the particular needs of our clients. The association is the main creator of Bright bars in India which differentiate and the best on earth. We process for all intents and purposes all standard surveys in various national and International specifications.we are making Bright Steel Bars in a combination of shapes and sizes according to various subtleties of steel, and fitting in with BSS, EN plan, SAE, ISI, DIN, AISI.",
    Specifications: {
      " Specifications": "ASTM B348/ ASTM SB348",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const TitaniumGr4BarData = [
  {
    text1:
      "Titanium Gr 4 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "We are Suppliers of Titanium Grade 4 Round Bar in India. Aries Alloys is a one of the most settled Distributor of Grade 4 Titanium Alloy Forged Bars in India. India's Largest Manufacturer of ASTM B348 Ti Gr4 Hex Bars offer Price Per Tone. We can give Titanium Grade 4 Threaded Bars at Dealer regard which makes us display incredible diverged from other Importer of Grade 4 Ti. Composite Black Bar in India. Titanium Alloy Grade 4 Rod Price in India. We are Dealer of DIN 3.7065 Titanium Gr 4 Square Bar, Ti UNS R50700 Bright Bar Stockholder in Mumbai, Ti Alloy Grade 4 Round Bars is utilized in a wide degree of mechanical applications from Petrochemicals, Off-Shore Oil Drilling Companies and mix to marine associations. Check animated Price of Gr4 Ti. Amalgam Bar in India. Purchase Titanium Gr 4 Polished Round Bar, most perfect circumstance Price in Bhiwandi, Nigeria, Bikaner, Kuwait, Surat, Pune and India. We can supply your relationship with veritable neighborhood ASME SB348 Titanium Gr 4 Cold Drawn Bar in surprising sizes that may not be open on the floor, Traders of Titanium Grade 4 Flat Bars in India. We offer Titanium Grade 4 Tig Rod in various sorts of Size, Shape, evaluations, thickness and estimations Exporter in India.",
    Specifications: {
      " Specifications": "ASTM B348/ ASTM SB348",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const TitaniumGr5BarData = [
  {
    text1:
      "Titanium Gr 5 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "Modi metals. gives decision endeavored bars to the better thought of bars. Improved machines and systems are utilized in social occasion approach of these bars. Titanium Grade 5 Bars are the better choice for entire arrangement association at most reasonable costs. Referenced bars are passed on as packs and encased by plastic to keep up a key division from any reimbursement of bars.",
    Specifications: {
      " Specifications": "ASTM B348/ ASTM SB348",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const A286BarData = [
  {
    text1:
      "A-286 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "Triangular Bars is age – hardenable for high mechanical properties. Truth be told, the indented break nature of our Alloy A286 Bars is superior to anything distinctive differing business mixes with in each handy sense ambiguous high temperature properties. These Alloy A286 Rods is used in conveyor and current gas turbine, super – charger zones, stream engines, sharp edges, wheels, castings, plots, secure, affiliations, rib nuts, screws, max motor motivation parts.",
    Specifications: {
      " Specifications": "ASTM B348/ ASTM SB348",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const SMO254BarData = [
  {
    text1:
      "SMO 254 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "SMO 254 bars, These bars are tried with assortment of parameters for guaranteeing strength and nature of bars. These bars have phenomenal nature of consumption and scraped area safe. SMO bars are generally utilized by specialists in view of its definitive quality. These oppose locking and pounding in effort of overwhelming burdens. With astounding component of wearing high temperatures it is appropriate for warming ventures. These are in a perfect world utilized for structuring development works.",
    Specifications: {
      " Specifications": "ASTM A276 / ASTM SA276 / ASTM A479 / ASTM SA479",
      Dimensions: "\tEN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const  HastelloyBarGradeData=[

  {
    id:1,
    grade:'Hastelloy C22 Round Bar',
    link:'/HastelloyC22BarGrade'
  },
  {
    id:2,
    grade:'Hastelloy C276 Round Bar',
    link:'/HastelloyC276BarGrade'
  },
  

  
]
export const HastelloyBarData = [
  {
    text1:
      "Hastelloy Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "A boss among the most usage – safe fuels, these Hastelloy Hexagonal Bars is awesome in high – stress applications and in conditions inclined to repeated warm stun. This Hastelloy Triangular Bars additionally offers ideal protection from conditions where reducing and oxidizing conditions are learned about procedure streams. Welding of our Hastelloy Bars ought to be possible by gas tungsten – round segment, gas metal – contort and guaranteed metal – twist outlines. We are addressed noteworthy master in these Hastelloy Rods and with broadened lengths of commitment in gathering the equivalent, we offer wonderful thing and lower cost of it yet with the best association.",
    Specifications: {
      " Specifications": "ASTM B574 / ASTM SB574",
      Dimensions: "\tEN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const HastelloyC22BarData = [
  {
    text1:
      "Hastelloy C22 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "These highlights look like surprising security from use, high check, noteworthy dimensional exactness, extraordinary weight rot breaking hindrance, against perilous, and so forth. It is open in different structures like a round Bar, astounding bar, round Bar, shaped bar, round bar, dull bar. So as to guarantee that Hastelloy C22 bars are made of good quality, different tests is done to check its quality. The tests that are exceedingly sensible is certain material evident affirmation test, leveling test, flaring test, full scale and cut back scale test, substance, and mechanical test, setting square test, ultrasonic test, and so on. During the period of national or thorough transport of referenced dispatch, fitting bundling winds up essential. The thing is full utilizing wooden holders/beds/boxes, compartment boxes, and so on to give enough achievement to the thing.",
    Specifications: {
      " Specifications": "ASTM B574 / ASTM SB574",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const HastelloyC276BarData = [
  {
    text1:
      "Hastelloy C276 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "Hastelloy Alloy C276 Round Bars, where clients can pick these things from various focal obsessions and sizes as showed up by their sensible plans. These Hastelloy C276 round Bars is molybdenum – nickel – chromium made mix that is framed as the most adaptable utilize safe compound imperative.",
    Specifications: {
      " Specifications": "ASTM B574 / ASTM SB574",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];

export const Alloy20BarData = [
  {
    text1:
      "Alloy 20 Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "The Alloy 20 bars creators are advancing MTC in learning to EN 10204/3.1B, unforgiving material accreditations, 100% radiography test report, removed examination report, etc. The material testing that has achieved the high check of bars appearances. The testing is a positive material test, full scale test, little scale test, intergranular crippling test, substance test, mechanical test, hardness test, smoothing test, flaring test, etc. The standard detail of these blend 20 bars is AISI, ASTM, etc. It offers various subtleties like sizes, shapes, estimations, diagrams, divider thickness, etc as appeared by the intensity of the buyer. Its structures are round, square shape, square, level, wire work, support, Hex. Long and check, it is open as per the customer's bit of breathing room. The thing is available at market driving rates to private and when all is said in done clients. Generally appear about the detail to a shipper and get it from us.",
    Specifications: {
      " Specifications": "ASTM B473 / ASTM SB473",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
export const DuplexBarData = [
  {
    text1:
      "Duplex/Superduplex Round Bar Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "",
    text3:
      "The introduction of welds in Super Duplex Steel Hollow Bars will depend upon the weld microstructure and filler metal. Duplex Steel Hexagonal Bars is fused into Sulfide Stress Cracking Resistant Metallic Materials for Oil Field Equipment. Plan toughened Super Duplex Steel Triangular Bars and cold worked are sufficient for use at any temperature up to 450 Degree F (232 Degree C) in sharp circumstances if the fragmentary load of hydrogen sulfide does not outperform 0.3 psi, the yield nature of the material is not any more imperative than 160 ksi, and if its hardness isn't more essential than 36 HRC",
    Specifications: {
      " Specifications": "ASTM A276, ASME SA276",
      Dimensions: "EN, DIN, JIS, ASTM, BS, ASME, AISI",
      Size: "5 mm To 500 mm",
      Diameter: "0.1 mm to 100 mm",
      Length: "100 mm To 3000 mm Long & Above",
      Finish:
        "Black, Bright Polished, Rough Turned, NO.4 Finish, Matt Finish, BA Finish",
      Tolerance:
        "H8, H9, H10, H11, H12, H13K9, K10, K11, K12 or as per clients’ requirements",
      Form: "Round, Square, Hex (A/F), Rectangle, Billet, Ingot, Forging Etc.",
    },
    chemical: {},
  },
];
